exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-group-sm>.btn [class*=\" la-\"][data-v-f3b5a4ba],.btn-group-sm>.btn [class^=la-][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class*=\" flaticon2-\"][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class*=\" flaticon-\"][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class^=flaticon2-][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class^=flaticon-][data-v-f3b5a4ba],.btn.btn-sm [class*=\" la-\"][data-v-f3b5a4ba],.btn.btn-sm [class^=la-][data-v-f3b5a4ba]{font-size:1rem!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-f3b5a4ba","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/BeerClaim/SearchBeerClaim.vue
// module id = 1037
// module chunks = 0